import EducationSummaryBox from "./EducationSummaryBox";

export default EducationSummaryBox;
